<template>
  <!-- Table Container Card -->
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        :label="$t('List page')"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>

    <form-wizard
      ref="addCorporateProfileForm"
      :title="null"
      :subtitle="null"
      layout="vertical"
      :back-button-text="$t('Previous')"
      class="wizard-vertical mb-3"
    >
      <!-- Account Number tab -->
      <tab-content
        :title="$t('Account Number')"
        :before-change="handleAccountSearch"
      >
        <validation-observer ref="accountNumberRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t("Account Number") }}
            </h5>
            <b-row class="match-height">
              <!-- Account Number -->
              <b-col md="6">
                <InputField
                  id="account-number"
                  v-model="customerInformationFormData.accountNumber"
                  :label="$t('Account Number')"
                  :placeholder="$t('Enter account number')"
                  type="number"
                  :error-name="$t('Account Number')"
                  rules="required"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Account Number -->

              <!-- <b-col md="2">
                <Button
                  label="Search"
                  size="md"
                  class="mt-2"
                  block
                  @click="handleAccountSearch"
                />
              </b-col> -->
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Contact Details tab -->
      <tab-content title="Account Details">
        <b-form>
          <h5 class="section-label mb-2">
            Confirm Account Details
          </h5>
          <b-row class="match-height">
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="customer-id"
                  v-model="customerInformationFormData.customerID"
                  :label="$t('Customer ID')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="account-name"
                  v-model="customerInformationFormData.accountName"
                  :label="$t('Account Name')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="account-number"
                  v-model="customerInformationFormData.accountNumber"
                  :label="$t('Account Number')"
                  type="number"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="account-type"
                  v-model="customerInformationFormData.accountType"
                  :label="$t('Account Type')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="branch"
                  v-model="customerInformationFormData.branchCode"
                  :label="$t('Branch')"
                  :reduce="(option) => option.value"
                  :options="branchOptions"
                  item="label"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="product-type"
                  v-model="customerInformationFormData.productCode"
                  :label="$t('Product Type')"
                  :reduce="(option) => option.value"
                  :options="productTypeOptions"
                  item="label"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="account-status"
                  v-model="customerInformationFormData.accountStatus"
                  :label="$t('Account Status')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="account-officer"
                  v-model="customerInformationFormData.accountOfficerID"
                  :label="$t('Account Officer')"
                  :reduce="(option) => option.value"
                  :options="allAccountOfficerOptions"
                  item="label"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="account-tier-level"
                  v-model.number="customerInformationFormData.accountTierLevel"
                  :label="$t('Account Tier Level')"
                  :options="accountTierOptions"
                  item="label"
                  :reduce="(option) => option.value"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="access-level"
                  v-model.number="customerInformationFormData.accessLevel"
                  :label="$t('Access Level')"
                  :reduce="(option) => option.value"
                  :options="accessLevelOptions"
                  item="label"
                  readonly
                />
              </b-col>
              <!--  Sector Code -->
              <b-col md="6">
                <SelectField
                  id="means-of-id"
                  v-model="customerInformationFormData.sectorCode"
                  :label="$t('Sector Code')"
                  :options="sectorCodeOptions"
                  :reduce="(option) => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  readonly
                />
              </b-col>
              <!--  Sector Code -->
              <!--  Category of Account -->
              <b-col md="6">
                <SelectField
                  id="means-of-id"
                  v-model="customerInformationFormData.categoryOfAccount"
                  :label="$t('Category of Account')"
                  :options="categoryOfAccountOptions"
                  :reduce="(option) => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  readonly
                />
              </b-col>
              <!--  Category of Account -->

              <b-col md="6">
                <SelectField
                  id="delivery-mode"
                  v-model="customerInformationFormData.statementDeliveryMode"
                  :label="$t('Delivery Mode')"
                  :reduce="(option) => option.value"
                  :options="deliveryModeOptions"
                  item="label"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="statement-delivery"
                  v-model="
                    customerInformationFormData.statementDeliveryFrequency
                  "
                  :label="$t('Frequency')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="minimum-balance"
                  v-model.number="
                    customerInformationFormData.minimumBalanceRequired
                  "
                  :label="$t('Minimum Balance Required')"
                  readonly
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="currency-code"
                  v-model="customerInformationFormData.currencyCode"
                  :label="$t('Currency')"
                  :reduce="(option) => option"
                  :options="currencyCodeOptions"
                  item="label"
                  :placeholder="$t('Select currency')"
                  readonly
                />
              </b-col>
            </b-row>

            <b-row class="d-flex align-items-center">
              <!--  Reference Number -->
              <b-col md="6">
                <InputField
                  id="reference-number"
                  v-model="customerInformationFormData.referenceNumber"
                  :label="$t('Reference Number')"
                  :placeholder="$t('Enter reference number')"
                  type="text"
                  show-icon
                  :on-click="onViewInfo"
                  readonly
                />
              </b-col>
              <!--  IPPIS/Oracle ID -->
              <b-col md="6">
                <InputField
                  id="ippis-oracle"
                  v-model="customerInformationFormData.employeeID"
                  :label="$t('IPPIS/Oracle ID')"
                  :placeholder="$t('Enter IPPIS/Oracle ID')"
                  type="text"
                  readonly
                />
              </b-col>
              <!--  IPPIS/Oracle ID -->
              <b-col md="6">
                <b-col
                  md="10"
                  class="mt-1"
                >
                  <div class="d-flex justify-content-between align-items-start">
                    <h6 class="">
                      {{ $t("Notify via") }}
                    </h6>

                    <b-form-checkbox
                      v-model="
                        customerInformationFormData.enableEmailNotification
                      "
                      inline
                      disabled
                    >
                      {{ $t("E-Mail") }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="
                        customerInformationFormData.enableSMSNotification
                      "
                      inline
                      disabled
                    >
                      {{ $t("SMS") }}
                    </b-form-checkbox>
                  </div>
                </b-col>
              </b-col>
            </b-row>

            <b-row class="match-height">
              <b-col md="6">
                <SwitchButton
                  v-model="
                    customerInformationFormData.overrideProductApplicableInterest
                  "
                  :label="$t('Override Product Applicable Interest')"
                  name="default-credit"
                  class="mt-2"
                  readonly
                />
                <div
                  v-if="
                    setDefaultApplicableInterest(
                      customerInformationFormData.overrideProductApplicableInterest
                    )
                  "
                >
                  <b-row>
                    <b-col md="6">
                      <SelectField
                        id="credit-interest"
                        v-model="
                          customerInformationFormData.applyCreditInterest
                        "
                        :label="$t('Apply Credit Interest')"
                        :reduce="(option) => option.value"
                        :options="applyOptions"
                        :placeholder="$t('Select')"
                        item="label"
                        readonly
                      />
                    </b-col>

                    <!-- Conditional -->
                    <b-col
                      v-if="isConditional"
                      md="6"
                    >
                      <SelectField
                        id="conditional"
                        v-model="interestConditionBasis"
                        :label="$t('Conditional')"
                        :reduce="(option) => option.value"
                        :options="conditionalOptions"
                        :placeholder="$t('Select')"
                        item="label"
                        readonly
                      />
                    </b-col>

                    <b-col
                      v-if="isCreditInterest"
                      md="6"
                    >
                      <InputField
                        id="credit-interest-rate"
                        v-model.number="
                          customerInformationFormData.interestRate
                        "
                        :label="$t('Credit Interest Rate')"
                        type="number"
                        readonly
                      />
                    </b-col>
                  </b-row>

                  <div>
                    <b-form
                      v-if="isConditional"
                      ref="form"
                      class="repeater-form"
                    >
                      <!-- Row Loop -->
                      <b-row
                        v-for="item in customerInformationFormData.productInterests"
                        :id="item.interestConditionValue"
                        :key="item.interestConditionValue"
                        ref="productInterest"
                        class="mt-2 d-flex align-items-center"
                      >
                        <b-col
                          v-if="isInterestNoOfWithdrawal"
                          md="6"
                        >
                          <!-- No of Withdrawals(times) -->
                          <InputNumberField
                            id="number-of-withdrawal"
                            v-model.number="item.interestConditionValue"
                            :label="$t('No of Withdrawals')"
                            readonly
                          />
                        </b-col>

                        <b-col
                          v-if="!isInterestNoOfWithdrawal"
                          md="6"
                        >
                          <!-- Customer's Balance (Amount) -->
                          <InputNumberField
                            id="customer-balance"
                            v-model="item.interestConditionValue"
                            :label="$t('Customer\'s Balance (Amount)')"
                            readonly
                          />
                        </b-col>

                        <b-col md="6">
                          <!-- Credit Interest Rate -->
                          <InputNumberField
                            id="credit-interest-rate"
                            v-model.number="item.interestRate"
                            :label="$t('Rate')"
                            readonly
                          />
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                </div>
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="
                    customerInformationFormData.overrideProductApplicableFee
                  "
                  :label="$t('Override Product Applicable Fee')"
                  name="cam-fee"
                  class="mt-2"
                  readonly
                />
                <div
                  v-if="
                    setProductApplicableFee(
                      customerInformationFormData.overrideProductApplicableFee
                    )
                  "
                >
                  <b-row>
                    <b-col md="6">
                      <SelectField
                        id="apply-fee"
                        v-model="customerInformationFormData.applyFee"
                        :label="$t('Apply Fee')"
                        :options="applyOptions"
                        :placeholder="$t('Select')"
                        :reduce="(option) => option.value"
                        item="label"
                        readonly
                      />
                    </b-col>

                    <b-col
                      v-if="isConditionalFee"
                      md="6"
                    >
                      <SelectField
                        id="conditional"
                        v-model="feeConditionBasis"
                        :label="$t('Conditional')"
                        :options="conditionalOptions"
                        :placeholder="$t('Select')"
                        :reduce="(option) => option.value"
                        item="label"
                        readonly
                      />
                    </b-col>
                  </b-row>

                  <div
                    v-if="isConditionalFee"
                    class="mb-5"
                  >
                    <b-form
                      ref="productFeeForm"
                      class="repeater-form"
                      @submit.prevent="repeatProductFees"
                    >
                      <!-- Row Loop -->
                      <b-row
                        v-for="item in customerInformationFormData.productFees"
                        :id="item.id"
                        :key="item.id"
                        ref="productFees"
                        class="align-items-center"
                      >
                        <b-col
                          v-if="isFeeNoOfWithdrawal"
                          md="6"
                        >
                          <!-- No of Withdrawals(times) -->
                          <InputNumberField
                            id="number-of-withdrawal"
                            v-model.number="item.feeConditionValue"
                            :label="$t('No of Withdrawal')"
                            readonly
                          />
                        </b-col>

                        <b-col
                          v-if="!isFeeNoOfWithdrawal"
                          md="6"
                        >
                          <!-- Customer's Balance (Amount) -->
                          <InputNumberField
                            id="customer-balance"
                            v-model.number="item.feeConditionValue"
                            :label="$t('Customer\'s Balance (Amount)')"
                            readonly
                          />
                        </b-col>
                        <!-- Conditional -->

                        <b-col md="6">
                          <!-- Flat Amount -->
                          <InputNumberField
                            id="flat-amt"
                            v-model.number="item.flatAmount"
                            :label="$t('Flat Amount')"
                            rules="required|positive"
                            :error-name="$t('Flat Amount')"
                            readonly
                          />
                        </b-col>
                        <b-col md="6">
                          <!-- Amount Per Transaction -->
                          <InputNumberField
                            id="amt-per-trans"
                            v-model.number="item.flatAmountPerTransaction"
                            :label="$t('Amount per Trans')"
                            readonly
                          />
                        </b-col>
                        <b-col md="6">
                          <!-- Percentage on Turnover -->
                          <InputField
                            id="percentage-on-turnover"
                            v-model.number="item.percentageOnTurnover"
                            :label="$t('% on Turnover')"
                            type="number"
                            readonly
                          />
                        </b-col>

                        <b-col md="6">
                          <!-- Minimum Amount To Charge -->
                          <InputNumberField
                            id="min-amount-to-charge"
                            v-model.number="item.minimumAmount"
                            :label="$t('Minimum Amount')"
                            readonly
                          />
                        </b-col>

                        <b-col md="6">
                          <!-- Maximum Amount To Charge -->
                          <InputNumberField
                            id="maximum-amount-to-charge"
                            v-model.number="item.maximumAmount"
                            :label="$t('Maximum Amount')"
                            readonly
                          />
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                  <b-row v-if="isApplyFee">
                    <b-col md="6">
                      <InputNumberField
                        id="flat-amount"
                        v-model="customerInformationFormData.flatAmount"
                        :label="$t('Flat Amount')"
                        :placeholder="$t('Enter flat amount')"
                        type="number"
                        readonly
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="flat-amount-per-transaction"
                        v-model="
                          customerInformationFormData.flatAmountPerTransaction
                        "
                        :label="$t('Flat Amount Per Transaction')"
                        :placeholder="$t('Enter flat amount per transaction')"
                        type="number"
                        readonly
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="percentage-on-turnover"
                        v-model="
                          customerInformationFormData.percentageOnTurnover
                        "
                        :label="$t('Percentage on Turnover')"
                        :placeholder="$t('Enter percentage on turnover')"
                        type="number"
                        readonly
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="maximum-amount-to-charge"
                        v-model.number="
                          customerInformationFormData.maximumAmount
                        "
                        :label="$t('Maximum Amount to Charge')"
                        :placeholder="$t('Enter maximum amount to charge')"
                        type="number"
                        readonly
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="minimum-amount-to-charge"
                        v-model.number="
                          customerInformationFormData.minimumAmount
                        "
                        :label="$t('Minimum Amount to Charge')"
                        :placeholder="$t('Enter minimum amount to charge')"
                        type="number"
                        readonly
                      />
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-row>
        </b-form>

        <h5 class="text-primary mb-2 mt-3">
          Group Members
        </h5>

        <b-table
          v-if="groupMemberList && groupMemberList.length"
          ref="groupMemberListTable"
          select-mode="single"
          :items="groupMemberList"
          responsive
          :fields="translatedGroupMembersHeader"
          :per-page="tablePageSize"
          :current-page="tableCurrentPage"
          primary-key="id"
          selectable
          show-empty
          :empty-text="$t('No data available')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="position-relative"
        >
          <template #cell(SN)="data">
            {{ groupMemberTableIndex(data.index) }}
          </template>
        </b-table>

        <h5 class="text-primary mb-2 mt-3">
          Mandate Information
        </h5>

        <b-table
          ref="signatoryListTable"
          select-mode="single"
          :items="signatoryList"
          responsive
          :fields="translatedSignatoryListHeaders"
          primary-key="id"
          selectable
          show-empty
          :empty-text="$t('No data available')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="position-relative"
        >
          <template #cell(SN)="data">
            {{ getOverallIndex(data.index) }}
          </template>

          <template #cell(select)="data">
            <b-form-group class="mt-2">
              <b-form-checkbox v-model="data.item.select" />
            </b-form-group>
          </template>

          <template #cell(passport)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.passport"
                  button
                  @click="
                    onViewPassport(data.item.passport, data.item.fullName)
                  "
                />
              </template>
            </b-media>
          </template>

          <template #cell(signature)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.signature"
                  button
                  @click="
                    onViewSignature(data.item.signature, data.item.fullName)
                  "
                />
              </template>
            </b-media>
          </template>
        </b-table>

        <h5 class="text-primary mb-2 mt-3">
          Mandate Information
        </h5>

        <div>
          <b-table
            ref="mandateListTable"
            select-mode="single"
            :items="mandateList"
            responsive
            :fields="translatedMandateListHeaders"
            primary-key="id"
            selectable
            show-empty
            :empty-text="$t('No data available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(isLimited)="data">
              {{ data.value === false ? "Unlimited" : "Limited" }}
            </template>
            <template #cell(amount)="data">
              {{ data.value === 0 ? "Unlimited" : toAmount(data.value) }}
            </template>
          </b-table>
        </div>
      </tab-content>

      <template slot="finish">
        <div class="wizard-footer-right">
          <Button
            label="Create Account"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>
      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title="Customer Details"
      cancel-title-only
      @hidden="resetModal"
    >
      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="tableHeaders"
        primary-key="id"
        selectable
        show-empty
        empty-text="No result found"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template #modal-footer="{}">
        <div />
      </template>
    </b-modal>

    <b-modal
      id="avatar-modal"
      ref="avatarModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="avatarModalTitle"
      @hidden="resetAvatarModal"
      @cancel="resetAvatarModal"
    >
      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <b-avatar
              size="30rem"
              :src="avatarLg"
            />
          </b-col>
        </b-row>
      </div>

      <template #modal-footer="{}">
        <div />
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BTable,
  BAvatar,
  BFormCheckbox,
  BFormGroup,
  BMedia,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { permissionMixin } from '@core/mixins/permission'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import InputField from '../../../forms/InputField.vue'
import InputNumberField from '../../../forms/InputNumberField.vue'
import SelectField from '../../../forms/SelectField.vue'
import { toAmount, formatAmount } from '@/helpers/formatAmount'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Button from '../../../components/button/Button.vue'
import SwitchButton from '../../../components/switch/Switch.vue'
import {
  accountTier, accessLevel, deliveryMode, frequency,
  categoryOfAccountOptions, sectorCodeOptions, applyInterest,
  conditionalOptions,
} from '../../../../helpers/data'
import { eChannelsPermission } from '../../../../helpers/permissions'
import { transformMandateRule } from '../../../../helpers/transformers'

export default {
  components: {
    BRow,
    BCol,
    BMedia,
    FormWizard,
    BAvatar,
    BFormCheckbox,
    BFormGroup,
    TabContent,
    BForm,
    ValidationObserver,
    InputField,
    InputNumberField,
    SelectField,
    Button,
    TablePagination,
    FullScreenSpinner,
    SwitchButton,
    BTable,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isReadonly: true,
      isBusy: false,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      sortBy: '',
      sortDesc: false,
      formatAmount,
      toAmount,
      buttonAction: 'Save',
      actionType: 'save',
      customerList: [],
      avatarLg: '',
      avatarModalTitle: '',
      tablePageSize: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      recordCount: 0,
      groupMemberList: [],
      feeConditionBasis: '',
      isApplyFee: false,
      isFeeNoOfWithdrawal: false,
      interestConditionBasis: '',
      isConditional: false,
      isConditionalFee: false,
      showAddProductInterest: false,
      productOptions: [],
      applyOptions: applyInterest,
      conditionalOptions,
      currencyCodeOptions: [],
      sectorCodeOptions,
      categoryOfAccountOptions,
      accessLevelOptions: accessLevel,
      deliveryModeOptions: deliveryMode,
      frequencyOptions: frequency,
      accountTierOptions: accountTier,
      allAccountOfficerOptions: [],
      productTypeOptions: [],
      accountOfficerOptions: [],
      mandateList: [],
      signatoryList: [],
      customerInformationFormData: {
        title: '',
        lastName: '',
        firstName: '',
        otherNames: '',
        accountNumber: '',
        bvn: '',
        state: '',
        nationality: '',
        dateOfBirth: null,
        gender: '',
        maritalStatus: '',
        meansOfIdentification: '',
        idNumber: '',
        meansOfIdentificationIssueDate: null,
        meansOfIdentificationExpiryDate: null,
        meansOfIdentificationPlaceOfIssue: '',
        phoneNumber: '',
        email: '',
        address: '',
        lga: '',
        nokName: '',
        nokDateOfBirth: null,
        nokAddress: '',
        nokGender: '',
        nokOccupation: '',
        nokRelationship: '',
        nokPhoneNumber: '',
        nokEmail: '',
        employeeIDType: '',
        employeeID: '',
        employeeIDNetIncome: null,
        employerName: '',
        employeeMDA: '',
        employeePayDate: null,
        stateOfEmployment: '',
        ministryOfLGA: '',
        employmentDate: null,
        employeeBankName: '',
        employeeBankAccountName: '',
        employeeBankAccountNumber: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'accountNumber', sortable: true },
      ],
      signatoryListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', sortable: true },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'fullName', sortable: true, label: 'Full Name' },
        { key: 'passport', sortable: true, label: 'Passport' },
        { key: 'signature', sortable: true, label: 'Signature' },
      ],
      groupMembersHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'phoneNumber', sortable: true, label: 'Phone Number' },
        { key: 'email', sortable: true, label: 'Email' },
      ],
      mandateListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'rule', sortable: true, label: 'Rule' },
        { key: 'isLimited', sortable: true, label: 'Limit' },
        { key: 'amount', sortable: true, label: 'Amount' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
      userDetails: 'auth/getCurrentUser',
    }),
    translatedGroupMembersHeader() {
      return this.groupMembersHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSignatoryListHeaders() {
      return this.signatoryListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMandateListHeaders() {
      return this.mandateListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    // this.fetchCustomerAccount()
    this.fetchProducts()
    this.fetchAccountOfficers()
    // this.fetchCASAProducts()
    this.fetchAllCurrencies()
    // this.fetchInstitutionLimitDetails()
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      getProducts: 'account/getProducts',
      getAllCurrencies: 'account/getAllCurrenciesAction',
      getAccountOfficers: 'account/getAccountOfficerList',
      getAccountSignatories: 'account/getAccountSignatoriesAction',
      getCustomerInformation: 'account/getCustomerInformation',
      createCorporateAccount: 'eChannels/createCorporateAccountAction',
      getGroupMembers: 'account/getGroupMembersByGroupId',
    }),
    backNavigationAction() {
      this.$router.push({
        name: 'enroll-corporate-profile',
      })
    },
    onViewInfo() {
      this.$root.$emit('bv::show::modal', 'info-modal')
    },
    async handleAccountSearch() {
      try {
        const success = await this.$refs.accountNumberRules.validate()
        if (success) {
          this.showSpinner = true
          const searchData = {
            search: {
              AccountNumber: this.customerInformationFormData.accountNumber,
            },
            page: this.currentPage,
            limit: this.perPage,
            permission: 'LOCAL_FUNDS_TRANSFER_POSTING',
          }
          const response = await this.searchCustomerAccount(searchData)
          const { status, data } = response
          if (status === 200) {
            this.customerList = data.data
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        }
        this.showSpinner = false
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    validateAccountNumber() {
      return new Promise((resolve, reject) => {
        this.$refs.accountNumberRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    setDefaultApplicableInterest(value) {
      if (!value) {
        this.customerInformationFormData.applicableInterest = null
        return false
      }
      return true
    },
    setProductApplicableFee(value) {
      if (!value) {
        this.customerInformationFormData.applicableFee = null
        return false
      }
      return true
    },
    groupMemberTableIndex(index) {
      return (this.tableCurrentPage * this.tablePerPage) - this.tablePerPage + index + 1
    },
    async onSelectCustomer(items) {
      try {
        this.hideModal('search-modal')
        this.showSpinner = true
        const [customer] = items

        this.customerInformationFormData = { ...customer }
        if (!customer.isGroupAccount) {
          this.alertError({ text: 'Please select a group account' })
          this.showSpinner = false
          return
        }
        this.groupMemberList = []
        if (customer.mandateRuleIndex !== null) {
          this.mandateList = transformMandateRule(customer.mandateRuleIndex)
        }

        if (customer.isGroupAccount) {
          const customerSignatory = await this.getAccountSignatories({ accountNumber: customer.accountNumber, permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS })
          this.signatoryList = customerSignatory.data.data ? customerSignatory.data.data.map(item => ({
            select: false,
            customerID: item.customerID,
            fullName: item.name,
            passport: item.passportFileUrl,
            signature: item.signatureFileUrl,
          })) : []
        }

        if (!customer.isGroupAccount) {
          const customerSignatory = await this.getCustomerInformation({ customerID: customer.customerID, permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS })
          this.signatoryList = [{
            fullName: customerSignatory.data.data.name,
            passport: customerSignatory.data.data.passportFileUrl,
            signature: customerSignatory.data.data.signatureFileUrl,
          }]
        }

        if (customer.isGroupAccount) {
          const response = await this.getGroupMembers({
            formData: {
              groupCustomerID: customer.customerID,
              pageNumber: 0,
              pageSize: 0,

            },
            permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS,
          })
          this.groupMemberList = response.data.data
          this.recordCount = response.data.recordCount
        }

        await this.$nextTick()
        if (this.$refs.addCorporateProfileForm) {
          this.$refs.addCorporateProfileForm.activeTabIndex = 1
          this.$refs.addCorporateProfileForm.activateTab(1)
        }

        // Spinner off only after tab navigation and data population
        this.showSpinner = false
      } catch (error) {
        this.alertError({ text: error })
        this.showSpinner = false
      }
    },
    async fetchProducts() {
      try {
        const { status, data } = await this.getProducts({
          search: '',
          page: 0,
          limit: 0,
          permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS,
        })

        if (status === 200 && data.data) {
          this.productTypeOptions = data?.data?.map(item => ({ label: item.name, value: item.code.toString() }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchAccountOfficers() {
      try {
        const { data, status } = await this.getAccountOfficers({
          search: '',
          page: 0,
          limit: 0,
          permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS,
        })

        if (status === 200 && data.data) {
          this.accountOfficerOptions = data?.data?.filter(item => item.status === 'Active').map(item => ({ label: item.name, value: item.id }))
          this.allAccountOfficerOptions = data?.data?.map(item => ({ label: item.name, value: item.id }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchAllCurrencies() {
      try {
        const response = await this.getAllCurrencies({ permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.currencyCodeOptions = data?.data?.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, curr.code], [])
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    onViewPassport(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s ${this.$t('Passport')}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    onViewSignature(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s ${this.$t('Signature')}`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    async addCorporateProfile() {
      try {
        this.showSpinner = true
        // const selectedMembers = this.groupMemberList.filter(item => item.select)
        const selectedMembers = this.signatoryList.filter(item => item.select)

        const formData = {
          accountNumber: this.customerInformationFormData.accountNumber,
          signatories: selectedMembers.length > 0 ? selectedMembers.map(item => ({
            customerID: item.customerID,
            role: '',
          })) : [],
        }

        const response = await this.createCorporateAccount({ formData, permission: eChannelsPermission.VIEW_INTERNET_BANKING_USERS })

        const { status, data } = response
        if (status === 200) {
          this.alertSuccess({ text: data.message })
          this.showSpinner = false
          this.$router.push({
            name: 'enroll-corporate-profile',
          })
        }
      } catch (error) {
        if (error && error.response && error.response.data) {
          this.handleError(error)
        } else {
          this.handleError({ message: error?.message || 'An unexpected error occurred.' })
        }
      } finally {
        this.showSpinner = false
        this.isLoading = false
      }
    },
    handleSubmit() {
      // Check if group member list exists and at least one group member is selected before showing confirmation
      if (!this.signatoryList || this.signatoryList.length === 0) {
        this.alertError({ text: 'Please select a group member first' })
        return
      }

      const selectedMembers = this.signatoryList.filter(item => item.select)

      if (selectedMembers.length === 0) {
        this.alertError({ text: 'Please select at least one group member to receive login details' })
        return
      }

      const actionText = 'Are you sure you want to Create a Corporate Account for this Account?'
      this.confirm(this.addCorporateProfile, { text: actionText })
    },
    resetModal() {
      this.showSpinner = false
      this.customerList = []
    },
    resetAvatarModal() {
      this.avatarLg = ''
      this.avatarModalTitle = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-image {
  border: 2px dashed #dcd9d9;
  position: relative;
  width: 250px;
  height: 250px;
}

.format {
  color: #999999 !important;
}

form input[type="file"] {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}

.upload-instruction {
  padding-top: 22%;
  color: #000;
  text-align: center;
}

.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}

.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import "../../../../@core/styles/global.css";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/base/bootstrap-extended/_include.scss";
</style>
